import { useEffect, useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { setLeaveAsker } from '@/lib/forms/unsavedChanges';

/**
 * The one question before unsaved changes are dropped (DESIGN.md §10).
 * Mounted once in App; `confirmLeave()` resolves with the answer.
 */
export function UnsavedChangesDialog() {
  const [pending, setPending] = useState<{ labels: string[]; resolve: (leave: boolean) => void } | null>(null);

  // Install the asker for as long as the dialog is mounted (one-time mount sync).
  // eslint-disable-next-line contruly/no-direct-use-effect -- one-time mount sync: installs the leave question, removed on unmount
  useEffect(() => {
    setLeaveAsker((labels) => new Promise<boolean>((resolve) => setPending({ labels, resolve })));
    return () => setLeaveAsker(null);
  }, []);

  const answer = (leave: boolean) => {
    pending?.resolve(leave);
    setPending(null);
  };

  const where = pending?.labels.join(', ') ?? '';

  return (
    <AlertDialog open={pending !== null} onOpenChange={(isOpen) => { if (!isOpen) answer(false); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Leave without saving?</AlertDialogTitle>
          <AlertDialogDescription>
            {where ? `Your changes in ${where} are not saved yet.` : 'Your changes are not saved yet.'} If you leave now, they are lost.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => answer(false)}>Keep editing</AlertDialogCancel>
          <AlertDialogAction onClick={() => answer(true)}>Leave without saving</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default UnsavedChangesDialog;
